<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product"v-loading="loading">

    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/category/add'">添加分类</el-button>
    </div>
            <el-select v-model="categoryModel.categoryType" @change="hindleChanged">
              <el-option label="--请选择分类模块--" :value="-1"></el-option>
              <el-option label="字帖分类" :value="0" ></el-option>
<!--              <el-option label="书法视频分类" :value="1"></el-option>-->
              <el-option label="视频分类" :value="2"></el-option>

            </el-select>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="categoryId" default-expand-all :tree-props="{children: 'children'}"
          style="width: 100%" >
          <el-table-column prop="name" label="分类名称" width="180"></el-table-column>
          <el-table-column prop="" label="图片" width="180">
            <template slot-scope="scope">
              <img v-img-url="hasImages(scope.row.imagePath)" alt="" width="50px" />
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="分类排序"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/category/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/product/category/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Add from './Add.vue';
  import Edit from './Edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        categoryModel: {
          categoryType: -1, // 与第一个选项的 :value 匹配

          catList: [],
          model: {}
        }
      };
    },
    created() {
      /*获取列表*/
      this.getData(this.categoryModel.categoryType);      console.log("-------------",this.categoryModel.catList);
    },
    methods: {
      hindleChanged(val){
        this.categoryModel.categoryType=val;
        this.getData(val);
      },
      hasImages(e) {
        if (e) {
          return e;
        } else {
          return '';
        }
      },

      /*获取列表*/
      getData(val) {

        let self = this;
        self.loading = true;

        PorductApi.catList({type: val
        }, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data;
            self.categoryModel.catList = self.tableData;
            console.log("##############",res.data)
            console.log("eeeee##############",self.categoryModel.catList)

          })
          .catch(error => {
            self.loading = false;
          });

      },
      /*打开添加*/
      addClick() {
        let self = this;

        if(self.categoryModel.categoryType=="-1"){
          alert("请先选择分类模块")
          return;
        }
        this.open_add = true;
      },

      /*打开编辑*/
      editClick(item) {
        this.categoryModel.model = item;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getData(this.categoryModel.categoryType);
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData(this.categoryModel.categoryType);
          }
        }
      },
      /*删除分类*/
      deleteClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          PorductApi.catDel({
            categoryId: row.categoryId
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData(this.categoryModel.categoryType);
          });
        });
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/category/index.vue